/**
 * Sentry frontend integration.
 *
 * Skipped entirely if EXPO_PUBLIC_SENTRY_DSN is not set.
 * Wide-net only: crash reporting, unhandled rejections, navigation breadcrumbs.
 */
import * as Sentry from '@sentry/react-native'

const DSN = process.env.EXPO_PUBLIC_SENTRY_DSN

export const isSentryEnabled = !!DSN

export function initSentry() {
  if (!DSN) return

  Sentry.init({
    dsn: DSN,
    environment: __DEV__ ? 'development' : 'production',
    enabled: !__DEV__,
    // Crash reporting + unhandled rejections (wide net)
    enableAutoSessionTracking: true,
    sessionTrackingIntervalMillis: 30_000,
    // Basic performance — low sample rate to stay within free tier
    tracesSampleRate: 0.1,
    // Breadcrumbs for navigation, console, network
    enableAutoPerformanceTracing: false,
    // Don't send PII
    sendDefaultPii: false,
  })
}

/**
 * Wrap the root navigator's onStateChange to log navigation breadcrumbs.
 */
export const routingInstrumentation = DSN
  ? Sentry.reactNavigationIntegration({ enableTimeToInitialDisplay: false })
  : null

/**
 * Set the authenticated user for error context.
 */
export function setSentryUser(user: { id: string; email?: string } | null) {
  if (!DSN) return
  if (user) {
    Sentry.setUser({ id: user.id, email: user.email })
  } else {
    Sentry.setUser(null)
  }
}

/**
 * Wrap the root component with Sentry's error boundary.
 * Returns the component as-is if Sentry is not configured.
 */
export function wrapWithSentry<P extends object>(
  component: React.ComponentType<P>,
): React.ComponentType<P> {
  if (!DSN) return component
  return Sentry.wrap(component)
}
